import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/joy/Button';

import { type UseToggle } from '@/shared/hooks/UseToggle';

import { DeleteIcon } from '../../icons/Icons';
import KpcModal from './layout/KpcModal';
import Row from './layout/Row';

type Props = {
  toggle: UseToggle<any>;
  onDelete: () => void;
  onCancel?: () => void;
  isDeleting?: boolean;
  hideOnClick?: boolean;
  bodyText?: string;
};

const DeleteModal: React.FC<Props> = ({
  toggle,
  onDelete,
  onCancel,
  isDeleting = false,
  hideOnClick = true,
  bodyText,
}) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    onDelete();

    if (hideOnClick) {
      toggle.hide();
    }
  };

  const handleCancel = () => {
    onCancel?.();
    toggle.hide();
  };

  return (
    <KpcModal
      className="w-1/2 overflow-y-scroll"
      icon={<DeleteIcon className="pr-2" />}
      title={t('modals.delete.title')}
      toggle={toggle}
      onClose={handleCancel}
    >
      <Row>{bodyText || t('modals.delete.description')}</Row>
      <Row className="justify-end">
        <Button size="sm" variant="soft" color="neutral" onClick={handleCancel}>
          {t('buttons.cancel')}
        </Button>
        <Button
          loading={isDeleting}
          size="sm"
          variant="solid"
          color="danger"
          onClick={handleDelete}
        >
          {t('buttons.delete')}
        </Button>
      </Row>
    </KpcModal>
  );
};

export default memo(DeleteModal);
